import { OyResponse } from '../Config';

export const KYB_PREFIX = 'business/kyb/v1';
export const LEGAL_DOC_URL = `${KYB_PREFIX}/legal-documents`;

export type LegalDocumentDataType = {
  id: string;
  file_name: string;
  type: string;
  status: string;
  product?: string;
  created: string;
};

export type LegalDocumentFileType = {
  file: string;
  file_name: string;
};

export type LegalDocumentsResponse = OyResponse<LegalDocumentDataType[]>;

export type LegalDocumentFileResponse = OyResponse<LegalDocumentFileType>;
